import { isLayerActive } from '../../makeup-flux-lab/utils/makeupLabResolve';
import { TIME_OF_USE_OPTIONS } from './makeupFluxV3TimePresets';

const CATEGORY_LABELS = {
  foundation: 'Foundation',
  concealer: 'Concealer',
  blush: 'Blush',
  eyeshadow: 'Eyeshadow',
  eyeliner: 'Eyeliner',
  eyelash: 'Eyelash',
  lipstick: 'Lipstick',
  highlighter: 'Highlighter',
  contour: 'Contour',
  eyebrows: 'Brows',
};

function timeOfUseLabel(timeOfUse) {
  return TIME_OF_USE_OPTIONS.find((t) => t.id === timeOfUse)?.label || timeOfUse || 'Day';
}

function layerSummary(category, layer) {
  if (!isLayerActive(layer)) return null;
  const parts = [];
  if (layer.name) parts.push(layer.name);
  else if (layer.option_id && layer.option_id !== 'none') parts.push(String(layer.option_id).replace(/_/g, ' '));
  if (layer.color) parts.push(layer.color);
  if (!parts.length) return null;
  return `${CATEGORY_LABELS[category] || category}: ${parts.join(' · ')}`;
}

/** Labels + modal copy for compare history after a makeup apply. */
export function buildMakeupHistoryFromStudio({ activePreset, timeOfUse, makeupLab, usedPresetId, meta }) {
  const presetName = activePreset?.label || activePreset?.name || '';
  const timeLabel = timeOfUseLabel(timeOfUse || activePreset?.timeOfUse);
  const label = presetName || (usedPresetId ? 'Makeup preset' : 'Custom makeup');
  const detailTitle = presetName || 'Custom makeup';
  const detailLines = [];
  if (presetName) detailLines.push(`Look: ${presetName}`);
  detailLines.push(`Time of use: ${timeLabel}`);
  for (const [cat, layer] of Object.entries(makeupLab || {})) {
    const line = layerSummary(cat, layer);
    if (line) detailLines.push(line);
  }
  if (meta && typeof meta === 'object') {
    if (meta.preset_id) detailLines.push(`Preset id: ${meta.preset_id}`);
    if (meta.delivery) detailLines.push(`Delivery: ${meta.delivery}`);
    if (meta.flux_blend != null) detailLines.push(`FLUX blend: ${meta.flux_blend}`);
    if (meta.normal_delivery_weight != null) {
      detailLines.push(`Composite weight: ${meta.normal_delivery_weight}`);
    }
    if (meta.rev) detailLines.push(`Backend: ${meta.rev}`);
    if (meta.seed != null) detailLines.push(`Seed: ${meta.seed}`);
  }
  return { label, detailTitle, detailLines };
}
